export function formatKennitala(kennitala: string) {
    if (kennitala.length > 6) {
        kennitala = kennitala.replace('-', '');
        kennitala = kennitala.substring(0, 6) + '-' + kennitala.substring(6, 10);
    }
    return kennitala;
}

export function formatKennitalaRemoveLine(kennitala: string) {
    return kennitala.replace('-', '');
}
